import styled from 'styled-components';

export const Container = styled.div`
  width: 300px;
  min-width: 300px;
`;
